var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useSlots as _useSlots, useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from "vue";
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, createElementVNode as _createElementVNode } from "vue";
import { ElInput, ElAutocomplete } from "element-plus";
import 'element-plus/es/components/input/style/css'
import 'element-plus/es/components/autocomplete/style/css'

import { Field } from "vee-validate";
import { computed, useAttrs } from "vue";
import axios from "@/js/lib/helper/axios";
import { hankaku as toHankaku } from "@/js/lib/helper/hankaku";
export default /* @__PURE__ */ _defineComponent({
  __name: "ITextField",
  props: /* @__PURE__ */ _mergeModels({
    name: {},
    type: { default: void 0 },
    title: { default: "" },
    rules: { default: "" },
    size: { default: "" },
    hankaku: { type: Boolean },
    price: { type: Boolean },
    apiPath: { default: "" },
    bankName: { default: "" },
    width: { default: "" },
    autocomplete: { default: void 0 }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props) {
    const props = __props;
    const attrs = useAttrs();
    const slots = _useSlots();
    const max = computed(() => {
      const regex = /^max(_simple)?:/;
      const maxRule = props.rules.split("|").find((item) => regex.test(item));
      return maxRule ? maxRule.replace(regex, "") : "";
    });
    const innerValue = _useModel(__props, "modelValue");
    const formatNumber = (value) => /^\d+$/.test(value) ? Number(value).toLocaleString() : value;
    const parseNumber = (value) => value.replaceAll(",", "");
    const formatHankaku = (value) => toHankaku(value);
    const querySearch = (q, cb) => __async(null, null, function* () {
      const res = yield axios.get(props.apiPath, { params: props.apiPath === "/api/bank/branch" ? { q, searchShop: true, bankName: props.bankName } : { q } });
      const data = res.data ? res.data.split("\n").map((value) => {
        return { value };
      }) : [];
      cb(data);
      return data;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_unref(Field), {
        modelValue: innerValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => innerValue.value = $event),
        name: _ctx.name,
        rules: _ctx.rules
      }, {
        default: _withCtx(({ field, handleChange, errors }) => [
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.title ? "label" : "div"), {
              class: _normalizeClass(_ctx.$style.label),
              style: _normalizeStyle(_ctx.width ? { maxWidth: `${_ctx.width}px` } : {})
            }, {
              default: _withCtx(() => [
                _ctx.title ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass([_ctx.$style.title, errors[0] && _ctx.$style.hasError])
                }, _toDisplayString(_ctx.title), 3)) : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _ctx.apiPath ? (_openBlock(), _createBlock(_unref(ElAutocomplete), _mergeProps({
                  key: 1,
                  "model-value": field.value,
                  "fetch-suggestions": querySearch,
                  class: [errors[0] && "error"]
                }, _unref(attrs), { "onUpdate:modelValue": handleChange }), null, 16, ["model-value", "class", "onUpdate:modelValue"])) : (_openBlock(), _createBlock(_unref(ElInput), _mergeProps({
                  key: 2,
                  name: _ctx.name,
                  "model-value": field.value,
                  type: _ctx.type,
                  autocomplete: _ctx.autocomplete,
                  "show-password": _ctx.type === "password",
                  formatter: _ctx.price ? formatNumber : _ctx.hankaku ? formatHankaku : void 0,
                  parser: _ctx.price ? parseNumber : void 0,
                  class: [_ctx.size === "medium" && _ctx.$style.medium, _ctx.price ? _ctx.$style.price : "", errors[0] && "error"]
                }, _unref(attrs), { "onUpdate:modelValue": handleChange }), null, 16, ["name", "model-value", "type", "autocomplete", "show-password", "formatter", "parser", "class", "onUpdate:modelValue"]))
              ]),
              _: 2,
              __: [1]
            }, 1032, ["class", "style"])),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.$style.errorWrap)
            }, [
              _ctx.type === "textarea" ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                errors[0] && !(max.value && typeof innerValue.value === "string" && innerValue.value.length > Number(max.value)) ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.error)
                }, _toDisplayString(errors[0]), 3)) : slots.help ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(_ctx.$style.help)
                }, [
                  _renderSlot(_ctx.$slots, "help")
                ], 2)) : _createCommentVNode("", true),
                _cache[2] || (_cache[2] = _createTextVNode()),
                max.value && typeof innerValue.value === "string" ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: _normalizeClass([_ctx.$style.counter, innerValue.value.length > Number(max.value) && _ctx.$style.error])
                }, _toDisplayString(innerValue.value.length) + " / " + _toDisplayString(max.value), 3)) : _createCommentVNode("", true)
              ], 64)) : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                errors[0] ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style.error)
                }, _toDisplayString(errors[0]), 3)) : slots.help ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: _normalizeClass(_ctx.$style.help)
                }, [
                  _renderSlot(_ctx.$slots, "help")
                ], 2)) : _createCommentVNode("", true)
              ], 64))
            ], 2)
          ])
        ]),
        _: 3
      }, 8, ["modelValue", "name", "rules"]);
    };
  }
});
